<template>
  <div v-if="type === 'array'">
    <div class="box" v-for="val in options" :class="selected(val) ? 'selected':''" :key="val" @click="select(val)">
      {{val}}
    </div>
  </div>
  <div v-else-if="type === 'object'">
    <div class="box" v-for="(val, key) in options" :class="selected(key, vals, val, multiple) ? 'selected':''" :key="key" @click="select(key)">
      {{val}}
    </div>
  </div>
  <div v-else>
    {{type}}
  </div>
</template>

<script>
export default {
  name: 'ConfigOption',
  data () {
    return {
      styles: ['list', 'boxes'],
      val: !this.multiple && this.value,
      vals: this.multiple && (this.value instanceof Set ? this.value : new Set()),
      setChangeTracker: 1
    }
  },
  props: {options: null, value: null, multiple: Boolean},
  methods: {
    select (val) {
      if (this.multiple === true) {
        if (this.vals.has(val)) {
          this.vals.delete(val)
        } else {
          this.vals.add(val)
        }
        this.$emit('input', this.vals)
        this.$emit('change', this.vals)
        this.setChangeTracker += 1
      } else {
        this.val = val
        this.$emit('input', this.val)
        this.$emit('change', this.val)
      }
    },
    selected (val) {
      if (this.multiple === true) {
        return this.setChangeTracker && this.vals.has(val)
      } else {
        return this.val === val
      }
    }
  },
  watch: {
    value (val) {
      if (this.multiple === true) {
        if (val instanceof Set) {
          this.vals = val
        } else {
          this.vals = new Set()
        }
      } else {
        if (this.type === 'array') {
          if (!this.options.includes(val)) {
            this.select(this.options[0])
          } else {
            this.val = val
          }
        } else {
          if (!(val in this.options)) {
            this.select(Object.keys(this.options)[0])
          } else {
            this.val = val
          }
        }
      }
    },
    options (opts) {
      if (this.multiple === true) {
        for (let item of Array.from(this.vals)) {
          if (this.type === 'array') {
            if (!opts.includes(item)) {
              this.vals.delete(item)
            }
          } else {
            if (!(this.val in opts)) {
              this.vals.delete(item)
            }
          }
        }
        this.setChangeTracker += 1
      } else {
        if (this.type === 'array') {
          if (!opts.includes(this.val)) {
            this.select(this.options[0])
          }
        } else {
          if (!(this.val in opts)) {
            this.select(Object.keys(this.options)[0])
          }
        }
      }
    }
  },
  computed: {
    type () {
      if (Array.isArray(this.options)) {
        return 'array'
      } else if (typeof this.options === 'object') {
        return 'object'
      } else {
        return typeof this.options
      }
    }
  }
}
</script>

<style scoped>
.option {
  padding: 5px;
  cursor: pointer;
}
.option.selected {
  color: red;
}

.box {
  margin: 6px 6px 0 0;
  border: 1px solid #b8b8b8;
  cursor: pointer;
  text-align: center;
  background-color: white;
  padding: 6px 24px;
}

.box:hover {
  border: 1px solid #54565A;
}

.box.selected {
  border: 1px solid #b8b8b8;
  border-bottom: 2px solid #ec6608;
}

.row {
  margin-bottom: 6px;
}

.row > .box {
  display: inline-block;
}

</style>



// WEBPACK FOOTER //
// src/components/ConfigOption.vue